/* eslint-disable no-shadow */
export enum ItemDetailsScreen {
  ItemDetailsPage = 'ItemDetailsPage',
  ItemReplacement = 'ItemReplacement',
  ItemScanner = 'ItemScanner',
  NSCItemScanner = 'NSCItemScanner',
  ItemUpdate = 'ItemUpdate',
  CustomItem = 'CustomItem',
  ItemLocationPage = 'ItemLocationPage',
  SubstituteItemDetailPage = 'SubstituteItemDetailPage',
  ReplacementItemDetailsPage = 'ReplacementItemDetailsPage',
}
